const SVG_MIME = 'data:image/svg+xml;utf8,';

const toSvgDataURI = (source: string): string => {
  if (source.startsWith('data:')) {
    return source;
  }

  return `${SVG_MIME}${encodeURIComponent(source)}`;
};

export {
  toSvgDataURI,
};
